module.exports = __webpack_public_path__ + "static/disco-poster-32dbfa2dbb5afad3debc1e91e2bbd6d2.jpg";